import * as Yup from 'yup';

import { messages } from '../format-template.messages';

export const validationSchema = Yup.object().shape({
  bucket: Yup.string().nullable(),
  templateId: Yup.string().nullable().required(messages.errSelectTemplate.defaultMessage),
  bandKey: Yup.string().nullable(),
  // REPLACE deletes the existing stages before the server rejects a stage-less template, so an
  // unresolved count (loading, skipped, failed) has to block submit just as hard as a zero one.
  previewStageCount: Yup.number()
    .nullable()
    .required(messages.errPreviewNotReady.defaultMessage)
    .min(1, messages.emptyTemplateWarning.defaultMessage),
  applyMode: Yup.string().oneOf(['APPEND', 'REPLACE']).required(),
});
